<template>
  <div class="card py-2 h-100 animated" :class="realtime ? 'amount-viewer' : ''">
    <div class="card-body pt-1 pb-1 d-flex align-items-center">
      <div>
        <div class="mb-1" :class="textClass">
          <template v-if="clickable">
            <span class="hover-underline hover-cursor" @click="$emit('click')">{{ title }}</span>
          </template>
          <template v-else>
            {{ title }}
          </template>
        </div>
        <spinner :with-text="false" :show="loading" spinner-size="1.25" :spinner-class="'my-0'"/>
        <div class="mb-0" v-if="!loading">
          <template v-if="typeof amount === 'object'">
            <template v-if="Object.keys(amount).length === 0">
              <span>{{ 0 | asCurrency(currency) }}</span>
            </template>
            <template v-else>
              {{ getAmountsString() }}
            </template>
          </template>
          <template v-else>{{ amount }}</template>
        </div>
      </div>
      <div class="ml-auto">
        <font-awesome-icon :icon="icon" class="icon" :class="textClass" style="font-size: 1.6em"/>
      </div>
    </div>
    <div v-if="realtime" class="blinking-dot" v-b-tooltip.hover.top="$t('Data updates in Realtime')"></div>
  </div>
</template>

<script>
  import Spinner from "@/core/components/common/Spinner";

  export default {
    name: "AmountViewer",
    components: {Spinner},
    props: {
      title: {
        type: [String, Number],
        required: true
      },
      amount: {
        type: [Number, String, Object],
        required: true
      },
      icon: {
        type: String,
        required: true
      },
      textClass: {
        type: String,
        default: 'text-primary'
      },
      currency: {
        type: String,
        default: null
      },
      loading: {
        type: Boolean,
        default: false
      },
      clickable: {
        type: Boolean,
        default: false,
      },
      realtime: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      getAmountsString() {
        let amountArr = [];
        for (let currencyCode in this.amount) {
          amountArr.push(this.$options.filters.asCurrencyByCode(this.amount[currencyCode], currencyCode))
        }
        return amountArr.join(' | ');
      }
    }
  }
</script>

<style lang="scss" scoped>
.amount-viewer {
  position: relative;
}
.blinking-dot {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 7px; /* Diameter */
  height: 7px; /* Diameter */
  background-color: #00ad3f;
  border-radius: 50%; /* Makes the dot round */
  animation: blink-animation 1.5s infinite; /* Blinking effect */
}

@keyframes blink-animation {
  0% {background-color: #00ad3f; }
  50% {background-color: transparent; }
  100% {background-color: #00ad3f; }
}
</style>
